import $ from 'jquery';
import dateParse from 'date-fns/parse';
import dateFormat from 'date-fns/format';

const $events = $('.js-events');
const $section = $('.js-events-section');
const $heading = $('.js-events-heading');
const $subheading = $('.js-events-subheading');
const $date = $('.js-events-date');
const $category = $('.js-events-category');
const $reset = $('.js-events-reset');
const $event = $('.js-event');

const defaultHeading = $heading.text();
const defaultSubheading = $subheading.text();

function getActiveDates(dateReturnFormat = 'yyyyMMdd') {
  if (!$date.length) {
    return false;
  }
  if (!$date.val()) {
    return false;
  }
  const dates = $date.val().split(' - ');
  const dateStart = dateParse(dates[0], 'MMMM d, yyyy', new Date());
  const dateEnd = dateParse(dates[1], 'MMMM d, yyyy', new Date());
  return [
    dateFormat(dateStart, dateReturnFormat),
    dateFormat(dateEnd, dateReturnFormat),
  ];
}

function getActiveCategory() {
  if (!$category.length) {
    return false;
  }
  if ($category.val() === 'all') {
    return false;
  }
  const $option = $category.find('option:selected');
  return {
    slug: $option.val(),
    name: $option.attr('data-category-name'),
    color: $option.attr('data-category-color'),
  };
}

function isEventDateActive(index, event) {
  const $event = $(event);
  const activeDates = getActiveDates('yyyyMMdd');
  if (!activeDates) {
    return true;
  }
  const dateStart = $event.attr('data-event-date-start');
  const dateEnd = $event.attr('data-event-date-end');
  if (!dateStart || !dateEnd) {
    return false;
  }
  return (
    // Start date is in range
    (Number(dateStart) >= Number(activeDates[0]) &&
      Number(dateStart) <= Number(activeDates[1])) ||
    // End date is in range
    (Number(dateEnd) >= Number(activeDates[0]) &&
      Number(dateEnd) <= Number(activeDates[1])) ||
    // Start and end dates surround range
    (Number(dateStart) <= Number(activeDates[0]) &&
      Number(dateEnd) >= Number(activeDates[1]))
  );
}

function isEventCategoryActive(index, event) {
  const $event = $(event);
  const activeCategory = getActiveCategory();
  if (!activeCategory) {
    return true;
  }
  const category = $event.attr('data-event-category');
  if (!category) {
    return false;
  }
  return category === activeCategory.slug;
}

function getActiveStyles() {
  const activeCategory = getActiveCategory();
  if (activeCategory) {
    return { '--background-color': activeCategory.color };
  }
  return { '--background-color': '' };
}

function getActiveHeading() {
  const activeCategory = getActiveCategory();
  const activeDates = getActiveDates();
  if (activeCategory) {
    return `Upcoming in ${activeCategory.name}`;
  }
  if (activeDates) {
    return `Upcoming Events`;
  }
  return defaultHeading;
}

function getActiveSubheading() {
  const activeCategory = getActiveCategory();
  const activeDates = getActiveDates('MMMM d, yyyy');
  if (activeCategory && activeDates) {
    return `You're viewing upcoming events in ${activeCategory.name} from ${activeDates[0]} to ${activeDates[1]}.`;
  }
  if (activeCategory) {
    return `You're viewing all upcoming events in ${activeCategory.name}.`;
  }
  if (activeDates) {
    return `You're viewing all upcoming events from ${activeDates[0]} to ${activeDates[1]}.`;
  }
  return defaultSubheading;
}

function filter() {
  const $eventResults = $event
    .hide()
    .filter(isEventDateActive)
    .filter(isEventCategoryActive)
    .show();

  $section.css(getActiveStyles());
  $heading.text(getActiveHeading());
  $subheading.text(getActiveSubheading());
  $reset.toggle($eventResults.length !== $event.length);

  if ($eventResults.length === $event.length) {
    //
  }

  if ($eventResults.length >= 1) {
    //
  }

  if ($eventResults.length <= 0) {
    $subheading.text(
      'Sorry, there are no events that match your filtering critera.'
    );
  }
}

function reset() {
  $date.val('');
  $date.data('picker').clear();
  $category.val('all');
  filter();
}

$date.on('change', filter);
$category.on('change', filter);
$reset.on('click', reset);
